/**
 * @file 従登録解除
 */
'use strict';

/**
 * @classname AdditionalTitleDelete
 * @classdesc 申請承認・再申請
 */
export default class AdditionalTitleDelete {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-exemption')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._titleId = $e.data('title-id');
		this._name = $e.data('name');
		this._memberId = $e.data('member-id');
		this._memberNo = $e.data('member-no');
		this._$modal = $('#modal-additional-title-delete');
		this._$form = $('#form-additional-title-delete');
		$e.on('click', () => this.onClick());
		this._$modal[0].addEventListener('hidden.bs.modal', () => this.onCloseModal());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof AdditionalTitleDelete
	 * @return {undefined}
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		this._$modal.find('.name').text(this._name);
		this._$modal.find('.member-no').text(this._memberNo);
		this._$form.find('.title_id').val(this._titleId);
		this._$form.find('.member_id').val(this._memberId);
	};



	/**
	 * modal closeのコールバック
	 *
	 * @memberof AdditionalTitleDelete
	 * @return {undefined}
	 */
	onCloseModal() {
		console.log(`${this.constructor.name}.onCloseModal`);
		this._$modal.find('.name').text('');
		this._$modal.find('.member-no').text('');
		this._$form.find('.title_id').val('');
		this._$form.find('.member_id').val('');
	};
}
